var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-overlay",
        { attrs: { show: _vm.isDownloading } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _vm.formularioRequerido
                    ? _c("h5", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("apeironGwApp.programa.obligatorio")
                          ),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.programaSeleccionado && _vm.esEscritura
                    ? _c("programa-select", {
                        attrs: {
                          disabled: !_vm.filtro.coordinadorCvu,
                          filtro: _vm.filtro,
                        },
                        on: { "programa-change": _vm.onProgramaChange },
                        model: {
                          value: _vm.form.programa,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "programa", $$v)
                          },
                          expression: "form.programa",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.programa?.id
                    ? _c("programa-resumen", {
                        attrs: { programa: _vm.form.programa },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  !_vm.programaSeleccionado &&
                  _vm.esEscritura &&
                  _vm.programaSeleccionadoValido
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.guardarPrograma()
                            },
                          },
                        },
                        [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(_vm.$t("entity.action.save")),
                            },
                          }),
                          _vm._v(" "),
                          _c("b-icon", { attrs: { icon: "save" } }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.programaGuardado && _vm.esEscritura
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.clonarParticipacionesMatriculas()
                            },
                          },
                        },
                        [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("apeironGwApp.programa.clonar")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("b-icon", { attrs: { icon: "save" } }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.programaGuardado && _vm.esEscritura
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.actualizarPrograma()
                            },
                          },
                        },
                        [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.programa.actualizarPrograma"
                                )
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("b-icon", { attrs: { icon: "cone-striped" } }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !!_vm.form.programa?.id
                    ? _c("pdfs-solicitud-posgrado", {
                        attrs: { solicitud: _vm.solicitud },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }